import { tw } from "@careinfo/tailwind";
import React from "react";

const StockValuationTable = ({
  data = {},
}: {
  data: Record<string, any[]>;
}) => {
  return (
    <div
      className={tw`overflow-x-auto  bg-[#fefefe] rounded-md border border-[#dcdcdc] shadow`}
    >
      <table className={tw`w-full rounded-md overflow-hidden border-collapse`}>
        <thead>
          <tr className={tw`text-white border-b bg-primary`}>
            <th className={tw`px-4 py-2 text-left`}>Product Name</th>
            <th className={tw`px-4 py-2 text-left`}>Unit</th>
            <th className={tw`px-4 py-2 text-left`}>Qunatity</th>
            <th className={tw`px-4 py-2 text-left`}>Rate</th>
            <th className={tw`px-4 py-2 text-left`}>Value</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(data).map(([productName, entries]) => {
            const rows = Array.isArray(entries) ? entries : [];

            const totalQuantity = rows.reduce(
              (sum, item) => sum + parseFloat(item?.closing_quantity || 0),
              0
            );

            const totalValue = rows.reduce(
              (sum, item) => sum + parseFloat(item?.total || 0),
              0
            );

            return (
              <React.Fragment key={productName}>
                <tr className={tw`bg-white border-b`}>
                  <td
                    colSpan={5}
                    className={tw`px-4 py-2 font-medium text-primary `}
                  >
                    {productName}
                  </td>
                </tr>
                {rows.map((item, index) => (
                  <tr key={item.id} className={tw`border-b`}>
                    <td className={tw`px-4 py-2`}>{item?.name}</td>
                    <td className={tw`px-4 py-2`}>{item?.unit?.name}</td>
                    <td className={tw`px-4 py-2`}>
                      {Number(item?.closing_quantity).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) ?? 0}
                    </td>
                    <td className={tw`px-4 py-2 `}>
                      {Number(item?.last_purchased_price).toLocaleString(
                        "en-IN"
                      ) ?? 0}
                    </td>
                    <td className={tw`px-4 py-2`}>
                      {Number(item?.total).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) ?? 0}
                    </td>
                  </tr>
                ))}
                <tr className={tw`bg-gray-200 font-semibold border-b`}>
                  <td className={tw`px-4 py-2`}>Total</td>
                  <td className={tw`px-4 py-2`}></td>
                  <td className={tw`px-4 py-2 `}>
                    {Number(totalQuantity.toFixed(2)).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  <td className={tw`px-4 py-2`}></td>
                  <td className={tw`px-4 py-2 `}>
                    {Number(totalValue.toFixed(2)).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StockValuationTable;
